import { Modal, Box, Button, TextField, Alert } from "@mui/material";
import { useState } from "react";
import axios from "axios";

export default function AddAttributeModal({ open, onClose, onCreated }) {
  const [form, setForm] = useState({
    attributeKey: "",
    attributeLabel: "",
    notes: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const token = sessionStorage.getItem("token");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrorMsg("");
  };

  const handleSave = async () => {
    if (!form.attributeKey || !form.attributeLabel) {
      setErrorMsg("Attribute Key and Label are required");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/attribute`,
        {
          attributeKey: form.attributeKey.trim(),
          attributeLabel: form.attributeLabel.trim(),
          notes: form.notes?.trim(),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      onCreated?.();        // refresh list
      onClose();
      setForm({ attributeKey: "", attributeLabel: "", notes: "" });
    } catch (err) {
      if (err.response?.status === 409) {
        setErrorMsg("Attribute Key already exists");
      } else {
        setErrorMsg("Failed to create attribute. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: 420,
          bgcolor: "white",
          borderRadius: 2,
          p: 3,
          mx: "auto",
          mt: "10%",
        }}
      >
        <h6 className="mb-3">Add New Attribute</h6>

        {errorMsg && (
          <Alert severity="error" className="mb-2">
            {errorMsg}
          </Alert>
        )}

        <TextField
          fullWidth
          size="small"
          name="attributeKey"
          label="Attribute Key"
          value={form.attributeKey}
          onChange={handleChange}
          className="mb-3"
          required
        />

        <TextField
          fullWidth
          size="small"
          name="attributeLabel"
          label="Attribute Label"
          value={form.attributeLabel}
          onChange={handleChange}
          className="mb-3"
          required
        />

        <TextField
          fullWidth
          size="small"
          name="notes"
          label="Notes"
          value={form.notes}
          onChange={handleChange}
          multiline
          rows={3}
          className="mb-3"
        />

        <div className="d-flex justify-content-end gap-2">
          <Button size="small" variant="outlined" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button size="small" variant="contained" onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}